

exports.__esModule = true;
exports.$SelectFiRoute = undefined;

var _squid = require('squid');

require('xo-wallet-components/src/confirm-upop/route');

var _directive = require('./directive');

var $SelectFiRoute = exports.$SelectFiRoute = _squid.$ComponentRoute.extend('$SelectFiRoute', {
    path: 'selectFi',
    directive: _directive.$xoSelectFiComponent,
    titleContent: 'memberReview.selectFi',
    trackingData: {
        fptiState: 'choose_FI_interstitial',
        buzname: {
            'fullpage': {
                'pagename': '%::select-fi',
                'pagename2': '%::select-fi:member:hermes:',
                'version': 'member:%:'
            }
        }
    },
    children: [{
        name: '$xoConfirmUpopRoute',
        props: function props() {
            return {
                token: this.props.token,
                cardmodel: this.cardModel
            };
        },

        lazyRoute: 'xo-wallet-components/src/confirm-upop/route',
        slug: 'confirmUpop'
    }]
}); /* dynamic-import */

angular.value("$SelectFiRoute", $SelectFiRoute);
_squid.$ComponentRoute;

_directive.$xoSelectFiComponent;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-select-fi/route.js
// module id = ./pages/xo-select-fi/route.js
// module chunks = 0